export const DEFAULT_BRAND = {
  key: "DEFAULT",
  productName: "HubbleSTAR",
  logo: { src: require("@/assets/logo.svg"), width: "150px" },
  favicon: "/favicon.ico",
  colors: {
    primary: "#3F41D1",
    primaryDark: "#005B64",
    primarySoft: "#CFD5F1",
    secondary: "#82d2da",
    secondarySoft: "#caecef",
    accent: "#E697AB",
    onAccent: "#310000",
    surface: "#f7f7f7",
    surfaceAccent: "#fbf5f2",
  },
};

const NTP_BRAND = {
  key: "NTP",
  logo: { src: require("@/assets/II-TED_logo.svg"), width: "68px" },
};

const MESTA_BRAND = {
  key: "MESTA",
  productName: "ScholarQuest",
  logo: { src: require("@/assets/scholarquest_logo.svg"), width: "150px" },
};

const OSEHUB_BRAND = {
  key: "OSEHUB",
  productName: "OSE Hub",
  logo: {
    src: "https://firebasestorage.googleapis.com/v0/b/vgos-sss-dev.appspot.com/o/external_client_brand%2FOSEHUB%2Flogo.svg?alt=media&token=8cb5afa6-295b-466f-9e6d-835f5a3197a5",
    width: "150px",
  },
  colors: {
  },
};

export const bundledClients = [NTP_BRAND, MESTA_BRAND, OSEHUB_BRAND].reduce((acc, brand) => {
  acc[brand.key] = brand;
  return acc;
}, {});
